import React, { useState, useEffect, Fragment } from "react";
import { RETURNS_SEARCH, RETURNS_UI_URLS } from "../../../constants";
import dateFormat from 'dateformat';
import { styled } from '@mui/material/styles';
import Pagination from '@mui/material/Pagination';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { FormControl, MenuItem, Select, Snackbar, Alert, InputAdornment, OutlinedInput, PaginationItem, Typography } from "@mui/material";
import ClearIcon from '@mui/icons-material/Clear';
import IconButton from '@mui/material/IconButton';
import { useNavigate } from "react-router-dom";
import EmailDialog from "../email-dialog/email-select-dialog";
import './returned-orders.scss';
import ScrollToTop from '../../../components/ScrollToTop.js';
import checkCircleIcon from "../../../assets/images/icons/check-circle.svg"
import useWindowResize from "../../../hooks/useWindowResize.js";


function ReturnedOrders(props) {
    const [date, setDateValue] = useState('3Months');
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [filterData, setFilter] = useState([]);
    const [page, setPage] = React.useState(0);
    const [totalCount, setTotalCount] = React.useState(0)
    const [totalPages, setTotalPages] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [currentpage, setCurrentPage] = React.useState(1);
    const [data1, setRetailerData] = React.useState({});
    const [showtooltip, setShowTooltip] = useState(false);
    const [snackOpen, setSnackOpen] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const [snackbarProp, setSnackbarProp] = useState({});
    const [isLoaderEnable, setIsLoaderEnable] = useState(false);
    const [searchValuechange, setSearchValueChange] = React.useState(false);
    const [searchValue, setSearchValue] = useState('');
    const [orderNumber, setOrderNumber] = useState('');
    const [zipcode, setZipcode] = useState('');
    const [orderIdParam, setorderIdParam] = useState('');
    const [emailData, setEmailData] = useState('');
    const [searchFilters, setSearchFilters] = useState(null);
    const [showMore, setShowMore] = useState('');


    let navigate = useNavigate();

    let filterObj = props.data ? props.data : null;
    let retailerInfo = props.retailerData ? props.retailerData : JSON.parse(sessionStorage.getItem('retailerData'));

    const handleClearSearch = () => {
        setSearchValue('');
        setSearchFilters(null);
        returnSearch(fromDate, toDate, null, '1', rowsPerPage);
    }

    const openEmailDialog = (returnId, shipId, emailId) => {
        let d = {
            shipId: shipId,
            returnId: returnId,
            emailId: emailId
        }
        setEmailData(d)
        setOpen(true);
    };

    const dialogClose = (value) => {        
        if (value?.response) {
            setSnackOpen(true);
            setSnackbarProp({ style: 'success', msg: 'Notification sent to ' + value?.email });
        }
        else{
            setSnackOpen(true);
            setSnackbarProp({ style: 'error', msg: 'Unable to send notification to ' + value?.email });
        }
        setOpen(false);
    };

    const [searchValueDummy, setSearchValueDummy] = useState('');
    const searchParams = (event, value) => {
        event.preventDefault();
        setSearchValue(value);
        setSearchValueChange(true);
        if (value.length > 3 || value.length !== 0) {
            let filters = {
                "criteria_type": "Contains",
                "field_name": "rma_number",
                "field_type": "TEXT",
                "value": value
            }
            setSearchFilters(filters);
            setSearchValueDummy(JSON.parse(JSON.stringify(value)));
            returnSearch(fromDate, toDate, filters, '1', rowsPerPage);
        }
        else {
            setSearchFilters(null);
            returnSearch(fromDate, toDate, null, '1', rowsPerPage);
        }
    }

    const updateOrderInfoHeight = () => {
        setTimeout(() => {

            let orderInfoWrappers = document.querySelectorAll('.order-info-wrapper.auto-overflowY')
            // Iterate over each wrapper
            orderInfoWrappers.forEach((wrapper) => {
                let children = wrapper.children;
                let totalHeight = 0;

                // Calculate the combined height of the first three children
                for (let i = 0; i < Math.min(3, children.length); i++) {
                    totalHeight += children[i].offsetHeight;
                }

                // Update the max-height style of the wrapper
                wrapper.style.maxHeight = `${totalHeight + 60}px`;
            });
        }, [300])
    }

    useWindowResize(() => {
        updateOrderInfoHeight()
    })

    useEffect(() => {
        let params = new URLSearchParams(document.location.search);
        let o = decodeURIComponent(params.get("ordernumber"));
        setOrderNumber(o);
        let orderId = params.get("orderid");
        setorderIdParam(orderId);
        let z = params.get("zipcode");
        setZipcode(z)
        setRetailerData(JSON.parse(sessionStorage.getItem('retailerData')));
        let d = formatDate(new Date().setDate(new Date().getDate() - 90));
        setFromDate(d);
        let d1 = formatDate(new Date());
        setToDate(d1);
        setSearchValue('');
        setSearchFilters(null);
        returnSearch(d, d1, null, '1', 10, o, z, orderId);
    }, [filterObj]);

    const returnSearch = async (from, to, params, pageNo, size, o, z, orderId) => {
        let d;
        setIsLoaderEnable(true);
        if (o && z) {
            d = {
                "filters": [
                    {
                        "criteria_type": "Equals",
                        "field_name": "order_info.order_number",
                        "field_type": "TEXT",
                        "value": o
                    },
                    {
                        "criteria_type": "Equals",
                        "field_name": "order_info.buyer_address.zip_code",
                        "field_type": "TEXT",
                        "value": z
                    }
                ],
                "search_params": []
            }
        }
        else if (orderId) {
            d = {
                "filters": [
                    {
                        "criteria_type": "Equals",
                        "field_name": "order_info.order_id",
                        "field_type": "TEXT",
                        "value": orderId
                    }
                ],
                "search_params": []
            }
        }
        else if (JSON.parse(sessionStorage.getItem('email'))) {
            d = {
                "filters": [
                    {
                        "criteria_type": "Greater than or equal",
                        "field_name": "requested_dttm.formatted_dttm",
                        "field_type": "TIMESTAMP",
                        "value": from + "T00:00:00-05:00"
                    },
                    {
                        "criteria_type": "Less than or equal",
                        "field_name": "requested_dttm.formatted_dttm",
                        "field_type": "TIMESTAMP",
                        "value": to + "T23:59:59-05:00"
                    },
                    {
                        "criteria_type": "Equals",
                        "field_name": "order_info.email_id",
                        "field_type": "TEXT",
                        "value": JSON.parse(sessionStorage.getItem('email'))
                    }

                ],
                "search_params": []
            }
        }
        if (params) {
            d.filters = [params];
            let g = {
                "criteria_type": "Equals",
                "field_name": "order_info.email_id",
                "field_type": "TEXT",
                "value": JSON.parse(sessionStorage.getItem('email'))
            }
            d.filters.push(g);
        }
        try {
            const response = await fetch(RETURNS_SEARCH.Return_Search + (pageNo ? pageNo : '1') + '&size=' + (size ? size : 10), {
                method: 'POST',
                body: JSON.stringify(d),
                headers: {
                    'Content-Type': 'application/json',
                    'X-Fenix-Tenant-Id': (JSON.parse(sessionStorage.getItem('retailerData')).tenantId),
                }
            });
            if (!response) {
                setIsLoaderEnable(false);
                setFilter(null);
                setSnackOpen(true);
                setSnackbarProp({ style: 'error', msg: 'Fetching data is unsuccessfull.' });
                updateOrderInfoHeight()
            }
            if (response?.status === 200) {
                const result = await response.json();
                if (result?.data) {
                    setFilter(result);
                    setTotalCount(result?.meta?.total_count);
                    setTotalPages(result?.meta?.total_pages);
                    setCurrentPage(result.meta?.current_count + 1);
                    setPage(result.meta?.current_pages);
                    updateOrderInfoHeight()
                }
                else {
                    setFilter(null);
                    setTotalCount(0);
                    setTotalPages(0);
                    updateOrderInfoHeight()
                }
                setIsLoaderEnable(false);
            }
            else {
                setFilter(null);
                setSnackOpen(true);
                setSnackbarProp({ style: 'error', msg: 'Fetching data is unsuccessfull.' });
                setIsLoaderEnable(false);
                setTotalCount(0);
                setTotalPages(0);
                updateOrderInfoHeight()

            }
        }
        catch (error) {
            setFilter(null);
            setSnackOpen(true);
            setSnackbarProp({ style: 'error', msg: 'Fetching data is unsuccessfull.' });
            setIsLoaderEnable(false);
            setTotalCount(0);
            setTotalPages(0);
        }
    }

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackOpen(false);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        scrollToParticularSection('top-section');
        returnSearch(fromDate, toDate, searchFilters, newPage, rowsPerPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(1);
        returnSearch(fromDate, toDate, searchFilters, '1', parseInt(event.target.value, 10));
    };

    const dateSelected = (event) => {
        setDateValue(event.target.value);
        setSearchValue('');
        setSearchFilters(null);
        if (event.target.value === '3Months') {
            let d = formatDate(new Date().setDate(new Date().getDate() - 90));
            setFromDate(d);
            let d1 = formatDate(new Date());
            setToDate(d1);
            setTimeout(() => {
                returnSearch(d, d1, '', '1', rowsPerPage);
            }, 1000);
        }
        else if (event.target.value === 'Last30days') {
            let d = formatDate(new Date().setDate(new Date().getDate() - 30));
            setFromDate(d);
            let d1 = formatDate(new Date());
            setToDate(d1);
            setTimeout(() => {
                returnSearch(d, d1, '', '1', rowsPerPage);
            }, 1000);
        }
        else if (event.target.value === 'Last7days') {
            let d = formatDate(new Date().setDate(new Date().getDate() - 7));
            setFromDate(d);
            let d1 = formatDate(new Date());
            setToDate(d1);
            setTimeout(() => {
                returnSearch(d, d1, '', '1', rowsPerPage);
            }, 1000);
        }
        else if (event.target.value === 'Last15days') {
            let d = formatDate(new Date().setDate(new Date().getDate() - 15));
            setFromDate(d);
            let d1 = formatDate(new Date());
            setToDate(d1);
            setTimeout(() => {
                returnSearch(d, d1, '', '1', rowsPerPage);
            }, 1000);
        }
        else if (event.target.value === '6Months') {
            let d = formatDate(new Date().setDate(new Date().getDate() - 180));
            setFromDate(d);
            let d1 = formatDate(new Date());
            setToDate(d1);
            setTimeout(() => {
                returnSearch(d, d1, '', '1', rowsPerPage);
            }, 1000);
        }

        else if (event.target.value === 'year') {
            let d = formatDate(new Date().setDate(new Date().getDate() - 365));
            setFromDate(d);
            let d1 = formatDate(new Date());
            setToDate(d1);
            setTimeout(() => {
                returnSearch(d, d1, '', '1', rowsPerPage);
            }, 1000);
        }
    };

    const HtmlTooltipForAddress = styled(({ className, ...props }) => (
        <Tooltip {...props} classes={{ popper: className }} />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: '#f5f5f9',
            color: 'rgba(0, 0, 0, 0.87)',
            fontSize: theme.typography.pxToRem(12),
            border: '2px solid #dadde9',
        },
    }));
    const formatDate = (event) => {
        return (new Date(event)).toISOString().split('T')[0];;
    }

    const formatingDateForDisplay = (date) => {
        return dateFormat(date, "mmmm d, yyyy");
    }

    const removeunderscore = (returnstatus) => {
        let data = returnstatus?.replaceAll('_', ' ');
        return data?.toLowerCase().replace(/(?:^|[\s-/])\w/g, function (match) {
            return match?.toUpperCase();
        });;
    }

    const addDefaultImg = ev => {
        ev.target.src = "/shopping-bag.png";
        ev.target.style = 'width:45%';
    }

    const scrollToParticularSection = (id) => {
        const violation = document.getElementById(id);
        violation?.scrollIntoView({
            block: 'start',
        });
    }

    const genarateLabelURL = async (return_id, shipment_id, i, k) => {
        try {
            const response = await fetch(RETURNS_UI_URLS.BASE_URL + 'returns/' + return_id + '/shipment/' + shipment_id + '/generate-label', {
                method: 'POST',
                body: {},
                headers: {
                    'Content-Type': 'application/json',
                    'X-Fenix-Tenant-Id': (JSON.parse(sessionStorage.getItem('retailerData')).tenantId),
                }
            });
            if (!response) {
            }
            if (response?.status === 200) {
                const result = await response.json();
                if (result) {
                    if (filterData.data[i].return_shipment_summaries[k].label_summary) {
                        filterData.data[i].return_shipment_summaries[k].label_summary.url = result?.url;
                    }
                    else {
                        let data = {
                            url: result?.url
                        }
                        filterData.data[i].return_shipment_summaries[k].label_summary = data;
                    }
                    setFilter(filterData);
                    setSnackOpen(true);
                    setSnackbarProp({ style: 'success', msg: 'Label Generated Successfully.' });
                }
            }
            else {
                setSnackOpen(true);
                setSnackbarProp({ style: 'error', msg: 'Failed To Generate Label.' });
            }
        }
        catch (error) {
            setSnackOpen(true);
            setSnackbarProp({ style: 'error', msg: 'Failed To Generate Label.' });
        }
    }
    const genaratePackageSlipURL = async (shipment_id, i, k) => {
        try {
            const response = await fetch(RETURNS_UI_URLS.ADMIN_BASE_URL + 'return-shipment/' + shipment_id + '/regenerate-packing-slip', {
                method: 'POST',
                body: {},
                headers: {
                    'Content-Type': 'application/json',
                    'X-Fenix-Tenant-Id': (JSON.parse(sessionStorage.getItem('retailerData')).tenantId),
                }
            });
            if (!response) {
            }
            if (response?.status === 200) {
                const result = await response.json();
                if (result) {
                    filterData.data[i].return_shipment_summaries[k].packing_slip_url = result?.url;
                    setFilter(filterData)
                    setSnackOpen(true);
                    setSnackbarProp({ style: 'success', msg: 'Package Slip Generated Successfully.' })
                }
            }
            else {
                setSnackOpen(true);
                setSnackbarProp({ style: 'error', msg: 'Failed To Generate Package Slip.' });
            }

        }
        catch (error) {
            setSnackOpen(true);
            setSnackbarProp({ style: 'error', msg: 'Failed To Generate Package Slip.' });
        }
    }

    const gobacktologin = () => {
        let data2 = '/login'
        navigate(data2.replace(/"/g, ""));
    }
    const NoIcon = styled('span')(({ theme }) => ({
        display: 'none',
    }));

    const handleTouchStart = () => {
        setShowTooltip(true);
    }
    const handleTouchEnd = () => {
        setShowTooltip(false)
    }

    const backspaceCall = (e, value) => {
        if (value.length === 0 && e.key === 'Backspace') {
            e.preventDefault();
            setSearchValue(value)
            searchParams(e, value)
        }
    }

    const showMoreForNote = (id,type) => {
        if(type === 'less'){
            setShowMore('note'+id);
        }else{
            setShowMore('');   
        }
    }  

    const displaySizeandColorandQuantity = (size, color, qty) => {
        return size && color ? (<>{qty && <span>Order Qty: {qty}</span>}<span>{data1?.type === 'janieandjack' ? 'Size:' : 'Variant:'} {size}</span><span className='display-ellipsis width-25vw'>Color: {color}</span></>) : (size && !color ? <>{qty && <span>Order Qty: {qty}</span>} <span className='text-nowrap'>{data1?.type === 'janieandjack' ? 'Size:' : 'Variant:'} {size}</span></> : (!size && color ? <>{qty && <span>Order Qty: {qty}</span>} <span className='display-ellipsis width-25vw'>Color: {color}</span></> : ''))
    }

    const orderInfoContent = (linedata) => {
        return (
            <>
                <div className="order-info">
                    <div className='order-image-wrapper'>
                        <div className={`order-image ${!linedata.line_item?.image_url ? 'no-order-image' : ''} `}>
                            {data1.type !== 'fluentcommerce' ?
                                <img
                                    className={`img-block border-image mb-10 cursor-pointer ${!linedata.line_item?.image_url ? "width-45per" : ""}`}
                                    alt='linedata.line_item?'
                                    onClick={() => window.open(linedata.line_item?.routing_url ? linedata.line_item?.routing_url : retailerInfo.store_url)}
                                    src={linedata.line_item?.image_url ? `${linedata.line_item?.image_url}` : '/shopping-bag.png'}
                                    onError={addDefaultImg}
                                    style={{ width: 100 + 'px' }}
                                />
                                :
                                <img
                                    className={`img-block border-image mb-10 cursor-pointer ${!linedata.line_item?.image_url ? "width-45per" : ""}`}
                                    alt='linedata.line_item?'
                                    onClick={() => window.open(retailerInfo.store_url)}
                                    src={linedata.line_item?.image_url ? `${linedata.line_item?.image_url}` : '/shopping-bag.png'}
                                    onError={addDefaultImg} style={{ width: 100 + 'px' }}
                                />
                            }
                        </div>
                        {
                            linedata.line_item?.product_name ? <div className={`product_name_wrapper ${retailerInfo?.type} `}>
                                <h4 className={`display-ellipsis ${retailerInfo?.type}`}>
                                    {linedata.line_item?.product_name}
                                </h4>
                            </div> : (
                                <>
                                    <div className={`product_name_wrapper ${retailerInfo?.type}`}>
                                        <h4 className={`display-ellipsis ${retailerInfo?.type}`}>
                                            {linedata.line_item?.sku}
                                        </h4>
                                    </div>
                                </>
                            )
                        }
                    </div>
                    <div className="order-desc flex-grow-1">
                        <div className='desc-content'>
                            <div className='product_info'>
                                {linedata.line_item?.product_name ?
                                    <div className={`product_name_wrapper ${retailerInfo?.type}`}>
                                        <h4 className={`display-ellipsis ${retailerInfo?.type}`}>
                                            {linedata.line_item?.product_name}
                                        </h4>
                                    </div>
                                    :
                                    <div className={`product_name_wrapper ${retailerInfo?.type}`}>
                                        <h4 className={`display-ellipsis ${retailerInfo?.type}`}>
                                            {linedata.line_item?.sku}
                                        </h4>
                                    </div>
                                }
                                {(linedata?.line_item?.color || linedata?.line_item?.size || linedata.line_item?.quantity) ?
                                    <div className='size_color_wrapper'>
                                        {displaySizeandColorandQuantity(linedata?.line_item?.size, linedata?.line_item?.color, linedata.line_item?.quantity)}
                                    </div> : ''
                                }
                                {(linedata?.return_attributes?.return_reason?.title) ?
                                    <div className='size_color_wrapper'>
                                        <span className="display-ellipsis width-40vw">Reason: {linedata?.return_attributes?.return_reason?.title}</span>
                                    </div> : ''
                                }
                                {(linedata?.return_attributes?.customer_notes) ?
                                    <div className='size_color_wrapper width-40vw'>

                                        <span className="text-wrap">Customer Note: {showMore ? linedata?.return_attributes?.customer_notes : linedata?.return_attributes?.customer_notes.substring(0, 65)}
                                        {linedata?.return_attributes?.customer_notes.length > 65 && <span  >{showMore  === 'note'+linedata.id ? <span className={`${data1.type} cursor-pointer`} onClick={() => showMoreForNote(linedata.id,'more')}>show less</span>: <span className={`${data1.type} cursor-pointer`} onClick={() => showMoreForNote(linedata.id,'less')}>...show more</span>}</span>}</span>
                                        {/* <span className="display-ellipsis width-40vw" >Customer Note: {linedata?.return_attributes?.customer_notes}</span> */}
                                    </div> : ''
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }

    const renderForm = (
        <div className="container returned-orders-wrapper my-orders-wrapper" id="top-section">
            {sessionStorage.getItem('email') ? <div className="row my-orders-header">
                <div className="col-sm-8 col-md-6 col-12">
                    <div className="d-flex align-items-center order-place-lb-select">
                        <label className={`f-16 order-place-in-label ${retailerInfo?.type}`}> <span className="fw-600">{totalCount ? totalCount : '0'} item(s)</span> {!(searchValuechange && searchValue) ? 'returned in' : 'found'} </label>
                        {searchValuechange && searchValue ? '' :
                            <FormControl sx={{ m: 0 }} className={`form-control placed-in-select `}>
                                <Select className={`${data1.type} form-select p-10 search-border f-14 fw-500 past-days-wrapper`} IconComponent={NoIcon} defaultValue={date} onChange={dateSelected}
                                    labelId="demo-simple-select-helper-label"
                                    id="demo-simple-select-helper">
                                    <MenuItem className={`${data1?.type + '-menuitem'}`} value='Last7days'>Past 7 days</MenuItem>
                                    <MenuItem className={`${data1?.type + '-menuitem'}`} value='Last15days'>Past 15 days</MenuItem>
                                    <MenuItem className={`${data1?.type + '-menuitem'}`} value='Last30days'>Past 30 days</MenuItem>
                                    <MenuItem className={`${data1.type + '-menuitem'}`} value='3Months'>Past 3 Months</MenuItem>
                                    <MenuItem className={`${data1.type + '-menuitem'}`} value='6Months'>Past 6 Months</MenuItem>
                                    <MenuItem className={`${data1.type + '-menuitem'}`} value='year'>Past year</MenuItem>
                                </Select>
                            </FormControl>
                        }
                    </div>
                </div>
                {sessionStorage.getItem('email') && !document.location.href.includes('my-orders/return') ?
                    <div className="col-sm-4 col-md-6 input-wrapper justify-content-sm-end col-12">
                        <form onSubmit={e => searchParams(e, searchValue)} >
                            <FormControl fullWidth sx={{ m: 1 }}>
                                <OutlinedInput className={`fw-500 search-order-number-input form-control ${data1?.type}`}
                                    id="outlined-adornment-amount" onKeyUp={e => backspaceCall(e, e.target.value)} inputProps={{ maxLength: 25, }} placeholder='Search with RMA number'
                                    value={searchValue} onChange={e => searchParams(e, e.target.value)}
                                    startAdornment={<InputAdornment position="start">
                                        <IconButton onClick={handleClearSearch} edge="end">
                                            {searchValue?.length > 0 ? <ClearIcon className="f-12" /> : null}
                                        </IconButton>
                                    </InputAdornment>}
                                    label="Amount"
                                    endAdornment={<InputAdornment position="end">
                                    </InputAdornment>}
                                />
                            </FormControl>
                        </form>
                    </div> : ''}
            </div> : ''}

            <div className="row">
                <div className="col-12 card-wrap order-placed-lis">
                    {filterData?.data && filterData?.data.length > 0 ? filterData?.data?.map((data, i) => (
                        <div key={i} >
                            <div className="card order-placed-list-box">
                                <div className="card-header row mx-0 align-itesm-start">
                                    <div className='col-md-8 cheader-headings-wrap'>
                                        <div className="cheader-headings">
                                            <div className={`cheader-label ${data1?.type}`}>Order Placed</div>
                                            <div className={`fw-600 ${retailerInfo?.type} cheader-title`}>{data?.order_info?.placed_dttm?.actual_dttm ? formatingDateForDisplay(data?.order_info?.placed_dttm?.actual_dttm) : ''}</div>
                                        </div>
                                        {retailerInfo?.type !== 'janieandjack' ? <div className="cheader-headings">
                                            <div className={`cheader-label ${data1?.type}`}>Total Refund</div>
                                            <div className={`fw-600 ${retailerInfo?.type} cheader-title`}>$ {data?.refund_amount?.amount ? data?.refund_amount?.amount.toFixed(2) : '0'}</div>
                                        </div> : ''}
                                        <div className="cheader-headings ship-to-headings">
                                            <div className={`cheader-label ${data1?.type}`}>Ship to</div>
                                            <HtmlTooltipForAddress enterTouchDelay={0}
                                                className={`shipto-tooltip ${data1?.type}`}
                                                title={
                                                    <React.Fragment>
                                                        <div onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd} >
                                                            <h4>{data?.order_info?.buyer_address?.name}</h4>
                                                            <p>
                                                                {data?.order_info?.buyer_address?.address1} {data?.order_info?.buyer_address?.city},&nbsp;{data?.order_info?.buyer_address?.province} {data?.order_info?.buyer_address?.country}, &nbsp;{data?.order_info?.buyer_address?.zip_code}
                                                            </p>
                                                        </div>
                                                    </React.Fragment>
                                                }>
                                                <div className={`fw-600 ${retailerInfo?.type} cursor-pointer cheader-title`}>
                                                    {data?.order_info?.buyer_address?.name}
                                                    <span className="text-color">
                                                        <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path fillRule="evenodd" clipRule="evenodd" d="M11.2126 0.671822C11.4957 0.945189 11.4957 1.3884 11.2126 1.66177L6.37841 6.32844C6.09523 6.60181 5.63611 6.60181 5.35293 6.32844L0.787335 1.92103C0.504156 1.64766 0.504156 1.20445 0.787335 0.931081C1.07051 0.657714 1.52964 0.657714 1.81282 0.931081L5.86567 4.84351L10.1871 0.671822C10.4703 0.398455 10.9294 0.398455 11.2126 0.671822Z" fill="#78829D" />
                                                        </svg>

                                                    </span>
                                                </div>
                                            </HtmlTooltipForAddress>
                                        </div>
                                    </div>
                                    <div className="col-md-4 cheader-order-number">
                                        <div className="cheader-headings">
                                            <div className={`fw-600 cheader-label ${data1?.type}`}>Order Number: </div>
                                            <div className={`fw-600 ${retailerInfo?.type} cheader-title`}>{data.order_info?.order_number}</div>
                                        </div>
                                        <div className="cheader-headings">
                                            <div className={`fw-600 cheader-label ${data1?.type}`}>RMA: </div>
                                            <div className={`fw-600 ${retailerInfo?.type} cheader-title`}>{data.rma_number}</div>
                                        </div>
                                    </div>
                                    <div className='col-12 order-number-container'>
                                        <div className='order-number-header'>
                                            <span className='order-number-title'>Order Number:</span>
                                            <span className={`order-number-value fw-600 ${retailerInfo?.type} cursor-pointer`}>{data?.order_info?.order_number} </span>
                                        </div>
                                        <div className='order-number-header'>
                                            <span className='order-number-title'>RMA:</span>
                                            <span className={`order-number-value fw-600 ${retailerInfo?.type} cursor-pointer`}>{data.rma_number} </span>
                                        </div>
                                    </div>
                                </div>
                                <div className='card-body'>
                                    <div className="row m-0">
                                        <div className="col-md-12">
                                            <div className='card-subheader'>
                                                <div className='card-subheader-left'>
                                                    {(data?.status === 'RETURN_COMPLETED') ?
                                                        <div>
                                                            <p className={`RETURN_COMPLETE d-flex`}>
                                                                <img src={checkCircleIcon} alt='no icon' />
                                                                {(removeunderscore(data?.status))?.charAt(0).toUpperCase() + (removeunderscore(data?.status))?.slice(1).toLowerCase() + ' on '}{formatingDateForDisplay(data?.updated_dttm?.formatted_dttm)}
                                                            </p>
                                                        </div> :
                                                        <p className={`RETURN_REQUESTED`}>
                                                            {(removeunderscore(data?.status))?.charAt(0).toUpperCase() + (removeunderscore(data?.status))?.slice(1).toLowerCase() + ' on '}{formatingDateForDisplay(data?.requested_dttm?.formatted_dttm)}
                                                        </p>
                                                    }
                                                </div>
                                            </div>
                                            {(data.return_shipment_summaries && data.return_shipment_summaries.length > 0) ? data.return_shipment_summaries.map((lData, k) => {
                                                return (
                                                    <div className="return-order-list" key={k}>
                                                        {lData?.vendor ? <div className="fw-400 label-sold-shipped">
                                                            Product(s) Sold and Shipped by: <span className={`fw-600 ${data1.type}`}>{lData?.vendor}</span>
                                                        </div> : ''}
                                                        <div className="order-info-container">
                                                            <div className={`order-info-wrapper ${lData?.line_items?.length > 3 ? 'auto-overflowY' : 'auto-overflowY'}`}>
                                                                {lData?.line_items?.map((linedata, j) => {
                                                                    return (
                                                                        <Fragment key={j}>
                                                                            {orderInfoContent(linedata)}
                                                                        </Fragment>
                                                                    )
                                                                })}
                                                            </div>
                                                            <div className="btn-container">
                                                                {lData?.label_summary?.url ?
                                                                    <button className={`${data1?.type ? data1.type + '-btn' : ''}`} onClick={() => window.open(lData?.label_summary?.url)}>{lData.return_method.code === 'HR_RETURN_BAR' ? 'View QR Code' : 'Download Label'}</button> :
                                                                    <button className={`${data1?.type ? data1.type + '-btn' : ''}`} onClick={() => genarateLabelURL(data.return_id, lData.id, i, k)}>{lData.return_method.code === 'HR_RETURN_BAR' ? 'Generate QR Code' : 'Generate Label'}</button>}
                                                                {lData?.label_summary?.url && lData?.return_method.code !== 'HR_RETURN_BAR' ? (lData?.packing_slip_url ? <button className={`${data1.type ? data1.type + '-btn border-button' : ''}`} onClick={() => window.open(lData?.packing_slip_url, "download")}>Package Slip </button> :
                                                                    <button className={`${data1.type ? data1.type + '-btn' : ''}`} onClick={() => genaratePackageSlipURL(lData.id, i, k)}>Generate Package Slip </button>) : ''}

                                                                {(lData?.label_summary?.url && (lData?.label_summary.code_type !== 'QRCODE' ? lData?.packing_slip_url :true)) ? <button className={` ${data1.type} border-button`} onClick={e => openEmailDialog(data.return_id, lData.id, data?.order_info?.email_id)}>Send Email</button> : ''}
                                                            </div>
                                                        </div>
                                                    </div>)
                                            }
                                            ) : <div className='f-14 fw-500 text-center mt-16 mb-20'>No Line Items Found </div>}
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    )) : filterData === null || filterData.data === null ?
                        <div className={`${data1.type} f-14 fw-500 text-center min-height-50 align-center mt-16`}>
                            <div className='no-orders-border-line p-20'>
                                Welcome to <span className="fw-700">{data1?.vendorName}</span> Return Portal.
                                {searchValueDummy ?
                                    <div>It looks like you don’t have an order for <span className="fw-700 display-ellipsis">RMA: {searchValueDummy}</span></div>
                                    : (sessionStorage.getItem('email') ? <div>It looks like you don’t have any orders for <span className="fw-700 display-ellipsis">{JSON.parse(sessionStorage.getItem('email'))}</span></div>
                                        : (orderNumber ? <div>It looks like you don’t have an order for <span className="fw-700 display-ellipsis">Order Number:  {orderNumber}  & Zipcode:  {zipcode}</span></div> : <div>It looks like you don’t have an order for <span className="fw-700 display-ellipsis">Order Id:  {orderIdParam}</span></div>))}
                                <div><a href={() => false} className={`${data1.type} fw-700 cursor-pointer`} onClick={gobacktologin}>Logout</a></div> </div></div>
                        : ''}
                </div>
            </div>

            {totalCount > 10 ?
                <div className='custom_pagination'>

                    <div className='pagination-wrap'>
                        <div className='pagination_result_container'>
                            <label>Results:</label>
                            <FormControl sx={{ m: 1, minWidth: 90, mb: 2 }} size="small" variant='outlined'>
                                <Select classes={{
                                    root: "result-select-root",
                                }}
                                    value={rowsPerPage}
                                    onChange={handleChangeRowsPerPage}
                                    IconComponent={NoIcon}
                                    className={`form-select box-shadow-none cursor-pointer f-14`}>
                                    <MenuItem className={`f-14 quantity-menuitem ${data1.type + '-menuitem'}`} value={10}>10</MenuItem>
                                    <MenuItem className={`f-14 quantity-menuitem ${data1.type + '-menuitem'}`} value={50}>50</MenuItem>
                                    <MenuItem className={`f-14 quantity-menuitem ${data1.type + '-menuitem'}`} value={100}>100</MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                        <div className='pagination_container'>
                            <Pagination
                                className={`${data1?.type} table-page`}
                                count={totalPages}
                                variant="outlined"
                                onChange={handleChangePage}
                                shape="rounded"
                                page={page}
                                currentpage={currentpage}
                                renderItem={(item) => (
                                    <PaginationItem
                                        slots={{
                                            previous: () => (
                                                <Typography variant="label">Previous</Typography>
                                            ),
                                            next: () => (
                                                <Typography variant="label" sx={{ padding: "0 12px" }}>
                                                    Next
                                                </Typography>
                                            ),
                                        }}
                                        {...item}
                                    />
                                )}
                            />

                        </div>
                    </div>
                </div> : ''
            }
            <EmailDialog open={open} emailData={emailData}
                onClose={dialogClose} />

            <ScrollToTop />
            <Snackbar
                open={snackOpen}
                autoHideDuration={5000}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "center"
                }}
            >
                <Alert
                    onClose={handleClose}
                    severity={snackbarProp.style}
                    variant="filled"
                    sx={{ width: '100%' }}
                >{snackbarProp.msg}
                </Alert></Snackbar>
        </div>
    )
    return (
        <div>
            {isLoaderEnable && !searchValue ?
                <div className="min-height-50 align-center loader">{JSON.parse(sessionStorage.getItem('config-data'))?.pageload_buffering_message?.my_returns_page}</div>
                : renderForm
            }
        </div>
    );
}

export default ReturnedOrders;